
import React from 'react'
import { Redirect, Route } from 'react-router'
import ProTypes from 'prop-types'

export const PublicRauter = ({
    isAuthenticated,
    component: Component,
    ...rest//el resto de los elemtos caeran aqui

}) => {
     

    return (
        <Route {...rest}
            component={ (props) => (
                (!isAuthenticated)
                    ? <Component {...props} />
                    : (<Redirect to="/" />)
            )}
        />
    )
}
//ne secito ejecutar el la ruta del DashboardRoutes de manera 

PublicRauter.prototype = {
    isAuthenticated: ProTypes.bool.isRequired,
    component: ProTypes.func.isRequired,

}